/**
 * Planning Phase 5 (plan Task 11, design §11, D-663, D-708, D-713): the officer's badge and verified change list,
 * `planning.cleanup.changes`. Layer names, label ids and model names come from the stored list and are passed in as
 * plain text; people are named from the case the page holds, never from the list. ms and zh use the same placeholders
 * (planning-cleanup-changes-keys.spec.ts).
 */
export default {
  badge: 'Cleaned with AI: {{count}} changes ({{ai}} suggested by the AI)',
  title: 'What was changed',
  loading: 'Checking the change list…',
  close: 'Close',
  round: 'Round {{n}}',
  before: 'Before',
  after: 'After',
  approvedBy: 'Approved by {{name}} on {{date}}',
  proposedByRule: "Found by gisify's rules",
  proposedByModel: 'Suggested by {{provider}} {{model}}',
  proposedByModelRegion: 'Suggested by {{provider}} {{model}} in {{region}}',
  reverted: 'Undone by {{name}} on {{date}}',
  unknownPerson: 'another account',
  unverified: 'This change list could not be verified, so it is not shown.',
  none: 'This change list records no change.',
  leftOut: 'Saved as AutoCAD 2000',
  listMore: '{{items}} and {{more}} more',
  yes: 'yes',
  no: 'no',
  op: {
    rename_layer: 'Renamed a layer',
    explode_inserts: 'Broke blocks into their shapes',
    scale_units: 'Converted the drawing to metres',
    close_outline: 'Closed outlines whose gap was under 1 mm',
    join_pieces: 'Joined lines that met end to end into outlines',
    show_layer: 'Turned a layer on',
    remove_empty_layer: 'Removed an empty layer',
    remove_degenerate: 'Removed zero-length shapes',
    remove_duplicate: 'Removed duplicate shapes',
    text_to_mtext: 'Saved labels as multi-line text (the words did not change)',
    choose_site_boundary: 'Chose the site boundary',
    assign_layer: 'Moved a layer onto a standard layer',
    assign_shapes: 'Moved shapes onto a land-use layer',
    set_units: 'Set the unit the drawing was drawn in',
    attach_label: 'Attached a label to a plot',
    label_plot: 'Gave a plot its land use',
    remove_layers: 'Removed layers',
    remove_entities: 'Removed items the new file cannot hold',
  },
  field: {
    layer: 'Layer',
    layers: 'Layers',
    count: 'Number',
    type: 'Type',
    shapes: 'Shapes',
    shape: 'Shape',
    pieces: 'Pieces',
    outlines: 'Outlines',
    closed: 'Closed',
    on: 'Turned on',
    frozen: 'Frozen',
    removed: 'Removed',
    text: 'Text label',
    plot: 'Plot',
    moved: 'Moved',
    classCode: 'Land-use class',
    candidates: 'Candidates',
    entities: 'Items',
    unit: 'Unit',
    group: 'Group',
    insunits: 'Unit code',
    factor: 'Scale factor',
  },
} as const
